// @flow

import { SHARED_REQUEST_SET_ID } from './SharedRequest.actionTypes'

const initialState = {
  id: 0,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SHARED_REQUEST_SET_ID:
      return {
        id: action.id,
      }
    default:
      return state
  }
}
